export function generateKey(item) {
  return Date.now() + '_' + Math.random(0, 1) * 99999 + '_' + item.id
}
